import * as THREE from 'three';

/*
 * Type guard to check if a camera is an OrthographicCamera.
 * This is useful for distinguishing between PerspectiveCamera and OrthographicCamera.
 *
 * @param camera - The camera to check.
 * @returns True if the camera is an OrthographicCamera, false otherwise.
 */
export const isOrthographicCamera = (
  camera: THREE.PerspectiveCamera | THREE.OrthographicCamera,
): camera is THREE.OrthographicCamera =>
  (camera as THREE.OrthographicCamera).isOrthographicCamera !== undefined;
